import { CapabilitiesService } from '@mc/api'
import type { CapabilitiesResponse } from '../types/capabilities'

// Module-level cache variable
let cachedCapabilities: CapabilitiesResponse | undefined

export const getCapabilities = async (
  refresh = false,
): Promise<CapabilitiesResponse> => {
  try {
    // Return cached data if available and not refreshing
    if (cachedCapabilities && !refresh) {
      return Promise.resolve(cachedCapabilities)
    }

    // Fetch capabilities from the API
    const data = await CapabilitiesService.getCapabilities()

    // Cache the result
    cachedCapabilities = data

    return data
  } catch (error) {
    return Promise.resolve({ userCapabilities: [] })
  }
}

// Synchronous getter for cached capabilities (used by hasCapability)
export const getCachedCapabilities = (): CapabilitiesResponse | undefined =>
  cachedCapabilities

// Reset function for testing/logout scenarios
export const resetCapabilities = () => {
  cachedCapabilities = undefined
}
